import Repository from "./Repository";

export default {
  getAdminEarningsByYear(payload) {
    return Repository.get(`admin-annual-report/${payload}`);
  },
};
